<template>
  <div>
    <Drawer title="员工发薪委托书列表" :closable="true" v-model="show" width="80">
      <div class="add_options">
        <Button @click="view_faxinweituo_file" style="margin-right: 10px">发薪委托书模板下载</Button>
        <Button type="primary" @click="click_add">添加委托书</Button>
      </div>
      <div style="font-size: 13px;color:#fff;background-color: red;padding:10px;margin:10px">
        功能提示：添加委托书功能与工资卡功能合并，后续无须在此页面添加委托书，直接添加工资卡即可。
      </div>
      <div class="content">
        <Alert type="error">提示：添加委托书需要四要素一致，姓名、预留手机号、身份证号、银行卡号四要素，不一致则添加的委托书无效！</Alert>

        <div class="cert_inner" v-for="(item, i) in weituoshu_list" :key="i">
          <div class="del_cert" @click="del_weituo(item)">
            <Icon type="md-trash" />删除
          </div>
          <div class="card_list">
            <div class="card_left">
              <div>
                <span class="cert_name2">归属项目：</span>
                <span class="cert_value">{{ item.project_name }}</span>
              </div>
              <div>
                <span class="cert_name2">提交时间：</span>
                <span class="cert_value">{{ item.create_time_fmt }}</span>
              </div>

              <div>
                <span class="cert_name2">委托人姓名：</span>
                <span class="cert_value">{{ item.weituo_name }}</span>
              </div>
              <div>
                <span class="cert_name2">委托人身份证号：</span>
                <span class="cert_value">{{ item.weituo_idcard }}</span>
              </div>

              <div class="weituo_img_div">
                <span class="cert_name2">薪资委托收款书：</span>
                <div>
                  <img @click="view_file2(item.weituo_file_url)" class="weituoshu_img" :src="item.weituo_file_url"
                    alt="" />
                </div>
              </div>
            </div>

            <div>
              <div>
                <span class="cert_name2">受托人四要素校验：</span>
                <Tag color="success" v-if="item.audit_status == 1">{{
                  item.audit_remarks
                }}</Tag>
                <Tag color="error" v-else>{{ item.audit_remarks }}</Tag>
              </div>
              <div>
                <span class="cert_name2">受托人姓名：</span>
                <span class="cert_value">{{ item.shoutuo_name }}</span>
              </div>
              <div>
                <span class="cert_name2">受托人手机号：</span>
                <span class="cert_value">{{ item.shoutuo_phone }}</span>
              </div>
              <div>
                <span class="cert_name2">受托人身份证号：</span>
                <span class="cert_value">{{ item.shoutuo_idcard }}</span>
              </div>
              <div>
                <span class="cert_name2">受托人银行名称：</span>
                <span class="cert_value">{{ item.shoutuo_bankname }}</span>
              </div>
              <div>
                <span class="cert_name2">受托人银行卡号：</span>
                <span class="cert_value">{{ item.shoutuo_bankcard }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal v-model="add_show" title="添加委托书" :mask-closable="false" :footer-hide="true" width="500">
        <Alert type="warning">重要提示：添加委托书会对受托人银行卡四要素[姓名、预留手机号、银行卡号、身份证号]进行校验，请确保填写真实！
        </Alert>
        <div class="add_input">
          <div class="add_input_title">员工姓名：</div>
          <div>
            <Input v-model="add_item.name" placeholder="请输入" style="width: 300px" />
          </div>
        </div>

        <div class="add_input">
          <div class="add_input_title">员工身份证号：</div>
          <div>
            <Input maxlength="18" v-model="add_item.idcard" placeholder="请输入" style="width: 300px" />
          </div>
        </div>
        <div class="add_input">
          <div class="add_input_title">委托收款原因：</div>
          <div>
            <Input v-model="add_item.remarks" placeholder="请输入" style="width: 300px" />
          </div>
        </div>
        <div style="border-bottom: 1px solid #eee; margin: 15px 0"></div>
        <div class="add_input">
          <div class="add_input_title">受托人姓名：</div>
          <div>
            <Input v-model="add_item.weituo_name" placeholder="请输入" style="width: 300px" />
          </div>
        </div>
        <div class="add_input">
          <div class="add_input_title">受托人手机号：</div>
          <div>
            <Input maxlength="11" v-model="add_item.weituo_phone" placeholder="请输入" style="width: 300px" />
          </div>
        </div>
        <div class="add_input">
          <div class="add_input_title">受托人身份证号：</div>
          <div>
            <Input maxlength="18" v-model="add_item.weituo_idcard" placeholder="请输入" style="width: 300px" />
          </div>
        </div>
        <div class="add_input">
          <div class="add_input_title">受托人银行名称：</div>
          <div>
            <Input v-model="add_item.weituo_bankname" placeholder="请输入" style="width: 300px" />
          </div>
        </div>
        <div class="add_input">
          <div class="add_input_title">受托人银行卡号：</div>
          <div>
            <Input v-model="add_item.weituo_bankcard" placeholder="请输入" style="width: 300px" />
          </div>
        </div>
        <div class="add_input">
          <div class="add_input_title">薪资委托收款书：</div>
          <div>
            <div v-if="add_item.weituo_file_url" @click="view_file">
              <img :src="add_item.weituo_file_url" class="file_url" alt="" />
              <div class="del_file" @click.stop="del_file()">删除</div>
            </div>

            <Upload v-else :action="upload_url" :on-success="success_change">
              <Button icon="ios-cloud-upload-outline">点击上传委托书照片</Button>
            </Upload>
          </div>
        </div>
        <div class="add_optins">
          <Button type="primary" @click="add_weituoshu">确认添加</Button>
        </div>
      </Modal>
    </Drawer>
  </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

export default {
  name: "staff_faxin_weituo",
  data() {
    return {
      show: false,
      resume_id: "",
      project_id: "",
      add_item: {
        name: "",
        idcard: "",
        remarks: "",
        weituo_name: "",
        weituo_phone: "",
        weituo_idcard: "",
        weituo_bankname: "",
        weituo_bankcard: "",
        weituo_file: "",
        weituo_file_url: "",
      },
      upload_url:
        process.env.VUE_APP_HOST +
        "/roster_manage/payment_weituoshu/upload_weituoshu?token=" +
        this.$cookies.get("dx_token"),
      add_show: false,
      weituoshu_list: [],
    };
  },
  methods: {
    view_faxinweituo_file() {
      open_new_page(
        "https://static.daxiangsys.com/dx-short-link/xls/薪资委托收款书.docx"
      );
    },
    click_view(item) { },

    success_change(e) {
      console.log(e);
      if (e.code == 0) {
        this.add_item.weituo_file = e.data.object_name;
        this.add_item.weituo_file_url = e.data.url;
        this.$Message.success(e.msg);
      } else {
        this.$Message.error(e.msg);
      }
    },

    del_file() {
      this.add_item.weituo_file = "";
      this.add_item.weituo_file_url = "";
    },

    click_add() {
      this.$Modal.confirm({
        title: '重要提示',
        content: '<p>该功能已经弃用，与工资卡功能合并，请到花名册添加工资卡即可</p>',
        onOk: () => {
          
        },
        onCancel: () => {
          
        }

      });
      
      return
      this.add_show = true;

      this.add_item = {
        name: "",
        idcard: "",
        remarks: "",
        weituo_name: "",
        weituo_phone: "",
        weituo_idcard: "",
        weituo_bankname: "",
        weituo_bankcard: "",
        weituo_file: "",
        weituo_file_url: "",
      };
    },

    click_copy(e) {
      this.$Copy({
        text: e,
      });
    },
    del_weituo(item) {
      var that = this;
      this.$Modal.confirm({
        title: "提示",
        content: "<p>正在删除委托书，是否继续？</p>",
        onOk: () => {
          that.del_weituo_request(item);
        },
        onCancel: () => { },
      });
    },

    del_weituo_request(item) {
      var that = this;

      var _dict = {
        weituo_id: item.weituo_id,
        project_id: item.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/payment_weituoshu/del_weituoshu",
        _dict,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            this.get_weituo_list()
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    open(resume_id, project_id) {
      console.log(resume_id);
      console.log(project_id);
      this.show = true;
      var that = this;
      this.resume_id = resume_id;
      this.project_id = project_id;
      this.get_weituo_list()
    },

    get_weituo_list() {
      var that = this;

      var _dict = {
        resume_id: this.resume_id,
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/payment_weituoshu/weituoshu_list",
        _dict,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            console.log(res)
            that.weituoshu_list = res.data.weituo_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    add_weituoshu() {
      this.show = true;
      var that = this;

      if (this.add_item.name.length == 0) {
        this.$Message.error("请填写员工姓名");
        return;
      }
      if (this.add_item.idcard.length != 18) {
        this.$Message.error("请填写员工18位身份证");
        return;
      }
      if (this.add_item.remarks.length == 0) {
        this.$Message.error("请填写委托收款原因");
        return;
      }
      if (this.add_item.weituo_name.length == 0) {
        this.$Message.error("请填写受托人姓名");
        return;
      }
      if (this.add_item.weituo_phone.length != 11) {
        this.$Message.error("请填写受托人11位手机号");
        return;
      }
      if (this.add_item.weituo_idcard.length != 18) {
        this.$Message.error("请填写受托人18位身份证号");
        return;
      }
      if (this.add_item.weituo_bankname.length == 0) {
        this.$Message.error("请填写受托人银行名称");
        return;
      }
      if (this.add_item.weituo_bankcard.length == 0) {
        this.$Message.error("请填写受托人银行卡号");
        return;
      }
      if (this.add_item.weituo_file.length == 0) {
        this.$Message.error("请上传委托书文件");
        return;
      }

      var _dict = {
        resume_id: this.resume_id,
        project_id: this.project_id,
        name: this.add_item.name,
        idcard: this.add_item.idcard,
        remarks: this.add_item.remarks,
        weituo_name: this.add_item.weituo_name,
        weituo_phone: this.add_item.weituo_phone,
        weituo_idcard: this.add_item.weituo_idcard,
        weituo_bankname: this.add_item.weituo_bankname,
        weituo_bankcard: this.add_item.weituo_bankcard,
        weituo_file: this.add_item.weituo_file,
        weituo_file_url: this.add_item.weituo_file_url,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/payment_weituoshu/add_weituoshu",
        _dict,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.add_show = false;
            that.open(that.resume_id, that.project_id);
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    view_file() {
      this.$ImagePreview.show({
        previewList: [this.add_item.weituo_file_url],
      });
    },

    view_file2(url) {
      this.$ImagePreview.show({
        previewList: [url],
      });
    },
  },
};
</script>

<style scoped>
.del_cert {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
  font-size: 13px;
  color: red;
}

.del_file {
  font-size: 13px;
  cursor: pointer;
}

.del_file:hover {
  color: red;
}

.weituoshu_img {
  width: 60px;
  height: 60px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.add_options {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.add_input_title {
  width: 120px;
  flex-shrink: 0;
}

.add_input {
  margin: 5px 0;
  display: flex;
  align-items: center;
}

.file_url {
  width: 80px;
  height: 80px;
  border-radius: 5px;
  overflow: hidden;
  border: 1px solid #ccc;
  cursor: pointer;
}

.add_optins {
  display: flex;
  margin-top: 10px;
  justify-content: flex-end;
}

.bank_img {
  opacity: 0.3;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  position: absolute;
  right: 10px;
  top: 10px;
}

.cert_value {
  font-size: 13px;
}

.cert_name {
  font-weight: 600;
}

.cert_name2 {
  font-size: 13px;
}

.content {
  padding: 0 10px 10px 10px;
  display: flex;
  flex-wrap: wrap;
}

.copy_icon {
  margin-left: 5px;
  color: rgb(48, 120, 230);
  cursor: pointer;
}

.copy_txt {
  font-size: 13px;
}

.cert_inner {
  border: 1px solid #ececec;
  border-radius: 5px;
  box-shadow: 0 0 3px #ededed;
  padding: 10px 15px;
  width: 100%;
  margin: 0 10px 10px 0;
  cursor: pointer;
  position: relative;
}

.card_left {
  margin-right: 20px;
  padding-right: 20px;
  border-right: 1px solid #ccc;
}

.weituo_img_div {
  display: flex;
  align-items: center;
}

.card_list {
  display: flex;
}

/* .cert_inner:hover {
    background: #30445d;
    color: #fff;
  } */
</style>
